// material-ui
import Box from '@mui/material/Box';
import MainCard, { MainCardProps } from '@components/ui/cards/MainCard';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

function AuthCardWrapper({ children, ...other }: MainCardProps) {
  return (
    <MainCard
      sx={{
        maxWidth: { xs: 400, lg: 575 },
        margin: { xs: 2.5, md: 3 },
        '& > *': {
          flexGrow: 1,
          flexBasis: '50%',
        },
      }}
      content={false}
      backgroundColor="white"
      borderRadius={6}
      {...other}
    >
      <Box sx={{ p: { xs: 2, sm: 3, xl: 5 } }}>{children}</Box>
    </MainCard>
  );
}

export default AuthCardWrapper;
